import { render } from "./Home.vue?vue&type=template&id=6c6c7b8e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6c6c7b8e&lang=postcss"
script.render = render

export default script